import get from 'lodash.get';

class PrintDocumentButtonHelperServiceClass {
  getActiveFulfillments(fulfillments) {
    return fulfillments.filter((fulfillment) => !get(fulfillment, 'isLabelVoided'));
  }

  getActiveFulfillmentIds(fulfillments) {
    const activeFulfillments = this.getActiveFulfillments(fulfillments);
    return activeFulfillments.map((fill) => fill.fulfillmentId);
  }

  getFulfillmentPlanIdsWithLabel(fulfillments) {
    const activeFulfillments = this.getActiveFulfillments(fulfillments);
    return activeFulfillments.map((fulfillment) => get(fulfillment, 'fulfillmentPlanId'));
  }

  hasPrintedLabel(fulfillments) {
    return fulfillments.find((fulfillment) => get(fulfillment, 'labelPrintedStatus.isPrinted', false));
  }

  getPrintModalData(fulfillments) {
    const hasPrintedLabel = this.hasPrintedLabel(fulfillments);
    const activeFulfillmentIds = this.getActiveFulfillmentIds(fulfillments);
    const fulfillmentPlanIdsWithLabel = this.getFulfillmentPlanIdsWithLabel(fulfillments);
    return {
      hasPrintedLabel,
      activeFulfillmentIds,
      fulfillmentPlanIdsWithLabel,
    };
  }
}

export const PrintDocumentButtonHelperService = new PrintDocumentButtonHelperServiceClass();
